/**
 * KAN-743: картинка товара из фида; нет ссылки или картинка не загрузилась:
 * серая заглушка с иконкой.
 */
import { useState } from 'react';
import { Package } from 'lucide-react';
import { cn } from '@/lib/utils';
import { safeHttpUrl } from '@/lib/safeUrl';

interface ProductThumbProps {
  src: string | null | undefined;
  alt: string;
  className?: string;
  iconClassName?: string;
}

export function ProductThumb({ src, alt, className, iconClassName }: ProductThumbProps) {
  const [failed, setFailed] = useState(false);
  const safeSrc = safeHttpUrl(src);

  if (!safeSrc || failed) {
    return (
      <div
        data-testid="product-thumb-placeholder"
        className={cn('flex items-center justify-center rounded-md bg-gray-100 text-gray-400', className)}
        aria-label="Нет изображения"
        role="img"
      >
        <Package className={cn('h-5 w-5', iconClassName)} />
      </div>
    );
  }

  return (
    <img
      src={safeSrc}
      alt={alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={cn('rounded-md bg-white object-contain', className)}
    />
  );
}
